import { ref } from 'vue'

export const isCarRentalModalOpen = ref(false)
